import { GoogleLoginProvider, SocialAuthServiceConfig } from "@abacritt/angularx-social-login";

export const oauthConfig = {
    cognito: {
      userPoolId: 'eu-south-1_mSi5ZPr63',
      clientId: '69e26p12e88pe7ggla7tpa5rfn',
      redirectUri: '/dashboard',
      region: 'eu-south-1',
      endpoint: 'https://cognito.eu-south-1.amazonaws.com',
    },
  };


export const config: SocialAuthServiceConfig = {
  autoLogin: false, // Puoi configurare questo comportamento in base alle tue esigenze
  providers: [
    // {
    //   id: GoogleLoginProvider.PROVIDER_ID,
    //   provider: new GoogleLoginProvider('Your-Google-Client-Id'),
    // },
    // Aggiungi qui altre configurazioni per i provider se necessario
  ],
};